import { faStar } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider, Typography } from '@mui/material';
import './styles.css'
import { Fragment } from 'react';
import { CardGuiaMedicoProps } from '../../../interfaces/props/GuiaMedico/CardGuiaMedicoProps';
import { sxMarginCardItems } from './sxProps';
import { getIcone } from '../TipoServicoUtils';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { Doctor } from '../../../interfaces/entities/Doctor';

const CardGuiaMedico = ({ dados, icone, onFavoritoClicked, mostrarDisponibilidade }: CardGuiaMedicoProps) => {

	const accessibility = useAccessibility();

	const infoMedico = (doctor: Doctor, index: number) => {
		const nome = doctor.nomePessoa;
		const endereço = `${doctor.logradouro} ${doctor.numero} - ${doctor.bairro}, ${doctor.cidade} - ${doctor.uf}`
		const telefone = doctor.telefone;
		return `${nome} no endereço (${index + 1} de ${dados.length}) ${endereço}, telefone ${telefone}`
	}

	return (
		<div className='card-guia-medico' tabIndex={0} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
			<div className="icon-col">
				<FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={getIcone(icone)} className='card-icon'  />
			</div>
			<div className="info-col">
				{
					dados.map((doctor, i) =>
						<Fragment key={i}>
							<div className="content-area">
								<div>
									{ i === 0 && <Typography style={{...{ marginBottom: '5px'}, ...accessibility.textStyleAccessibility}}><strong>{doctor.nomePessoa}</strong></Typography> }
									{ doctor.numDoc && <Typography style={accessibility.textStyleAccessibility} sx={sxMarginCardItems}><strong>CNPJ: </strong>{doctor.numDoc}</Typography> }
									<Typography style={accessibility.textStyleAccessibility} sx={sxMarginCardItems}><strong>Especialidade: </strong>{doctor.descrEspec}</Typography>
									<Typography style={accessibility.textStyleAccessibility} sx={sxMarginCardItems}><strong>Endereço: </strong>{`${doctor.logradouro} ${doctor.numero} ${doctor.complemento} - ${doctor.bairro}, ${doctor.cidade} - ${doctor.uf}`}</Typography>
									<Typography style={accessibility.textStyleAccessibility} sx={sxMarginCardItems}><strong>Telefone: </strong>{doctor.telefone}</Typography>
									{ mostrarDisponibilidade && <Typography style={accessibility.textStyleAccessibility} sx={sxMarginCardItems}><strong>Provável disponibilidade: </strong>{doctor.dtDispon || 'Disponibilidade não informada' }</Typography> }
								</div>
								<button 
									style={{background: 'none', border: 'none', height: 'fit-content'}}   
									onClick={() => onFavoritoClicked(doctor)} 
									onKeyDown={key => { if (key.code === 'Enter') onFavoritoClicked(doctor); }}
									aria-label={doctor.isFavorito ? `Remover favorito ${infoMedico(doctor, i)}` : `Favoritar ${infoMedico(doctor, i)}`}
                >
									<FontAwesomeIcon
										icon={faStar} 
										className={`star-icon ${doctor.isFavorito && 'star-icon-selected'} ${i !== 0 && 'margin-top-10'}`} 
										title={doctor.isFavorito ? 'Remover favorito' : 'Favoritar'}
									/>
								</button>
							</div>
							{ i + 1 < dados.length && <Divider sx={sxMarginCardItems}/> }
						</Fragment>
					)
				}
			</div>
		</div>
	)
}

export default CardGuiaMedico;